var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStudyPatterns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.587,
    height: 95.531,
    viewBox: "0 0 123.587 95.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff005d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.155 -114.496)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.156 114.496)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.227 15.671)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M102.783,202.925h9.432c2.371,0,7.249.97,8.947-1.1a91.174,91.174,0,0,0,5.12-7.976c1.617-2.533,3.261-5.039,4.878-7.572-1.347-.189-2.695-.35-4.042-.539q2.344,14.148,4.662,28.295c.35,2.129,3.907,2.1,4.285,0l2.506-14.147c-.7.539-1.428,1.078-2.129,1.617h9.216a2.256,2.256,0,0,0,2.129-1.617q4.163-12.248,8.3-24.5c-1.455-.189-2.91-.4-4.366-.593v45.029c0,2.129,3.1,3.1,4.123,1.1q5.336-10.267,10.671-20.507c-.647.377-1.267.728-1.913,1.1h12.908c2.856,0,2.856-4.419,0-4.419H164.6a2.163,2.163,0,0,0-1.913,1.1q-5.336,10.267-10.671,20.507c1.374.377,2.749.755,4.123,1.1V174.792c0-2.56-3.557-2.91-4.366-.593q-4.163,12.248-8.3,24.5c.7-.539,1.428-1.078,2.129-1.617h-9.216a2.223,2.223,0,0,0-2.129,1.617l-2.506,14.147h4.285q-2.344-14.148-4.662-28.295c-.323-2.021-3.1-1.994-4.042-.539-3.341,5.174-6.683,10.375-10.024,15.549.647-.377,1.267-.728,1.913-1.1H102.756c-2.829.054-2.829,4.473.027,4.473Z",
    transform: "translate(-100.637 -172.649)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M127.305,114.5H36.546c-4.554,0-8.866,0-12.746,2.964-5.416,4.177-5.632,10.078-5.632,16.222v42.874c0,1.4-.027,2.829,0,4.231A14.684,14.684,0,0,0,24.8,192.914c3.773,2.425,7.923,2.237,12.18,2.237h83.214c2.8,0,5.686.189,8.488-.081a14.425,14.425,0,0,0,12.1-9.4,18.881,18.881,0,0,0,.862-6.6v-41.85c0-4.743.674-10.294-1.455-14.686a14.533,14.533,0,0,0-12.881-8.03c-2.856-.081-2.856,4.339,0,4.419a10.025,10.025,0,0,1,9.89,9.917c.027,1.24,0,2.452,0,3.692v41.149c0,4.689.808,10.186-2.668,13.9-3.126,3.341-7.141,3.126-11.264,3.126H62.308c-9.782,0-19.564.081-29.346,0-6.467-.054-10.375-4.824-10.375-11.022V163.272c0-11.48-.323-22.986,0-34.439a10.02,10.02,0,0,1,9.89-9.89c.62-.027,1.24,0,1.859,0h92.969C130.162,118.916,130.162,114.5,127.305,114.5Z",
    transform: "translate(-18.156 -114.496)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.863 91.111)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.092,457.019H202.58c2.856,0,2.856-4.419,0-4.419H157.092c-2.856,0-2.856,4.419,0,4.419Z",
    transform: "translate(-154.95 -452.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.304 76.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M279.142,400.384l4.2,14.875c.781,2.749,5.039,1.563,4.285-1.186l-4.2-14.875c-.808-2.722-5.066-1.563-4.285,1.186Z",
    transform: "translate(-279.046 -397.648)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.515 76.291)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M187.647,399.166l-4.2,14.875c-.781,2.749,3.5,3.934,4.285,1.186l4.2-14.875c.781-2.749-3.5-3.934-4.285-1.186Z",
    transform: "translate(-183.348 -397.604)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudyPatterns);
export default __webpack_public_path__ + "static/media/icon-study-patterns.40bce472263ff38bc9eff0fa02514204.svg";
export { ForwardRef as ReactComponent };